import { render, staticRenderFns } from "./OrderItemIndex.vue?vue&type=template&id=1ce6b018"
import script from "./OrderItemIndex.vue?vue&type=script&lang=js"
export * from "./OrderItemIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports